import createCrudService from '@core/api/create-crud-service';

import { QUERY_KEYS } from '@shared/constants/query-keys';
import type { TBaseQuery } from '@shared/types/base-query';
import { TExport } from '../types/export';
import { EXPORT_TYPES } from '../types/export';
import type { ValueOf } from '../types/utilities';

export type TExportQuery = TBaseQuery;

export type TExportPayload = {
  export_type: ValueOf<typeof EXPORT_TYPES>;
  view?: number;
};

const exportApi = createCrudService<TExport, TExportQuery, TExportPayload>({
  queryKey: [QUERY_KEYS.getExports],
  url: 'export-histories',
});

export default exportApi;
